import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import { Div, Loading, P } from 'konsys-ui'
import { UPDATE_USER } from '../../../constants/graphql/mutation'
import { GET_USER } from '../../../constants/graphql/query'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { ActionBar } from '../../../components/user-components'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW
  const [mutationVariables, setMutationVariables] = useState({
    type: 'CLIENT',
    warehouseId: [],
    new: true,
    customerId: [],
  })

  const onChangeHandler = (id, value) => {
    if (id === 'warehouseId') {
      if (value.isCheck === true) {
        return setMutationVariables({
          ...mutationVariables,
          [id]: _.uniq(mutationVariables.warehouseId.concat(value.warehouseId)),
        })
      }
      return setMutationVariables({
        ...mutationVariables,
        [id]: _.uniq(mutationVariables.warehouseId.filter(warehouseId => warehouseId !== value.warehouseId)),
      })
    }
    if (id === 'roleId') {
      return setMutationVariables({
        ...mutationVariables,
        [id]: value,
        driverId: null,
        customerId: [],
        senderLocationId: null,
        receiverLocationId: null,
      })
    }
    return setMutationVariables({
      ...mutationVariables,
      [id]: value,
    })
  }
  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? detailType(props.match.params, onChangeHandler)
          : isViewMode
            ? <Query
                query={GET_USER}
                fetchPolicy="network-only"
                variables={{ id: props.match.params.id }}
              >{({ data, error, loading }) => {
                if (loading && _.isEmpty(data)) return <Loading center='true' />
                if (error) return <P>เกิดข้อผิดพลาด</P>
                if (mutationVariables.new === true && data.UserInfo.Warehouses) {
                  setMutationVariables({
                    ...mutationVariables,
                    new: false,
                    warehouseId: data.UserInfo.Warehouses.map(warehouse => warehouse.id),
                    customerId: data.UserInfo.Customer.map(customer => ({ id: Math.random() * 10000, customerId: customer.id, name: customer.companyName })),
                  })
                }
                return detailType(props.match.params, onChangeHandler, data.UserInfo, mutationVariables) // argument mode
              }}
              </Query>
            : <Query
                query={GET_USER}
                fetchPolicy="network-only"
                variables={{ id: props.match.params.id }}
              >{({ data, error, loading }) => {
                if (loading && _.isEmpty(data)) return <Loading center='true' />
                if (error) return <P>เกิดข้อผิดพลาด</P>
                if (mutationVariables.new === true && data.UserInfo.Warehouses) {
                  setMutationVariables({
                    ...mutationVariables,
                    new: false,
                    warehouseId: data.UserInfo.Warehouses.map(warehouse => warehouse.id),
                    customerId: data.UserInfo.Customer.map(customer => ({ id: Math.random() * 10000, customerId: customer.id, name: customer.companyName })),
                  })
                }
                return detailType(props.match.params, onChangeHandler, data.UserInfo, mutationVariables) // argument mode
              }}
              </Query>
      }
      {/* ================== Footer section ================== */}
      {
        !isViewMode
          ? <Mutation
            mutation={UPDATE_USER}
          >{(doAction, { loading }) => (
            <ActionBar
              loading={loading}
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              doAction={doAction}
              mutationVariables={{ ...mutationVariables }}
              props={props}
            />
          )}
          </Mutation>
          : <ActionBar
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              props={props}
            />
      }
    </Div>
  )
}

export default Index
export { Index }
